import React, { useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import SydButton from '../../../../../commonDesign/Button'
import DebouncedInput from '../../../../../molecules/DebouncedInput'
import SydLabel from '../../../../../commonDesign/SydLabel'
import SydInput from '../../../../../commonDesign/SydInput'
import { useAssetSearchDeprecated } from '../../../../../../api/coreData'
import { assetItem, useDialogStyles } from './common'

function AddAssetForm ({ onComplete }) {
  const classes = useDialogStyles()

  const [searchText, setSearchText] = useState()
  const query = useMemo(() => {
    return {
      textSearch: {
        assetName: [{ op: 'contains', value: searchText }],
        assetIdentifier: [{ op: 'contains', value: searchText }]
      },
      take: 20
    }
  }, [searchText])
  const { data, isFetching } = useAssetSearchDeprecated(query)
  const weightRef = useRef()

  return (
    <>
      <div className={classes.form}>
        <div className={classes.formtings}>
          <SydLabel label='Search'>
            <DebouncedInput onChange={setSearchText} placeholder='Search Name / Identifier' style={{ height: 'unset', minHeight: '54px' }} />
          </SydLabel>
          <SydLabel label='Weight (bps)' description='E.g. enter 5.25% as 525'>
            <SydInput ref={weightRef} type='number' minWidth='0' />
          </SydLabel>
        </div>
        <div>
          {isFetching ? (
            <CircularProgress />
          ) : data?.length ? (
            <div className={classes.list}>
              <table className={classes.formTable}>
                <thead>
                  <tr>
                    <th>Identifier</th>
                    <th>Name</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map(x => (
                    <tr key={x.assetId}>
                      <td>{x.assetIdentifier}</td>
                      <td>{x.assetName}</td>
                      <td>
                        <SydButton size='xs' variant='primary' onClick={() => { onComplete(assetItem(x, weightRef.current.value)) }}>Add</SydButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div>No Results</div>
          )}
        </div>
      </div>
    </>
  )
}

AddAssetForm.propTypes = {
  onComplete: PropTypes.func
}

export default AddAssetForm
